import { v4 as uuidv4 } from 'uuid';
import { Base_URL } from '../Client/apiURL';

const SAFE_ROUTES = [/^\/$/, /dashboard/i, /^\/subscriptions?\/?$/i];
const BLOCKED_ROUTES = /(login|signup|password|checkout|payment|bank-transfer|mock-test\/|test-details|test-question|score|answer|teacher-mode|student\/.*result)/i;
const BEARER_IN_TEXT = /\bBearer\s+[A-Za-z0-9._~+/=-]+/gi;
const NAMED_SECRET_IN_TEXT = /\b(password|passcode|token|secret|api[_-]?key|access[_-]?token|refresh[_-]?token|credential)\s*([:=])\s*["']?[^&\s"',}\]]+/gi;
const AWS_KEY_IN_TEXT = /\b(?:AKIA|ASIA)[A-Z0-9]{16}\b/g;
const PRIVATE_KEY_IN_TEXT = /\b(?:sk-[A-Za-z0-9_-]{12,}|(?:sk|rk|pk)_(?:live|test)_[A-Za-z0-9_-]{8,})\b/g;

export function isReplayRouteEligible(path = '') {
  const pathname = String(path).split(/[?#]/)[0];
  return !BLOCKED_ROUTES.test(pathname) && SAFE_ROUTES.some((pattern) => pattern.test(pathname));
}

export function maskReplayText(text = '') {
  return String(text)
    .replace(BEARER_IN_TEXT, 'Bearer [masked]')
    .replace(NAMED_SECRET_IN_TEXT, '$1$2[masked]')
    .replace(AWS_KEY_IN_TEXT, '[masked]')
    .replace(PRIVATE_KEY_IN_TEXT, '[masked]')
    .replace(/[^\s@]+@[^\s@]+\.[^\s@]+/g, '[masked]')
    .replace(/\+?[\d][\d\s().-]{6,}[\d]/g, '[masked]');
}

export function shouldSampleReplay(sessionId, rate = 0.2) {
  if (rate <= 0) return false;
  if (rate >= 1) return true;
  let hash = 0;
  for (const char of String(sessionId)) hash = ((hash * 31) + char.charCodeAt(0)) >>> 0;
  return (hash % 10000) < Math.round(rate * 10000);
}

export function startMaskedReplay({ sessionId, path, upload = fetch }) {
  if (!isReplayRouteEligible(path) || !shouldSampleReplay(sessionId)) return () => {};
  let events = [];
  let startedAt = new Date().toISOString();
  let stopped = false;
  let stopRecording;
  let timer;

  const flush = () => {
    if (!events.length) return;
    const batch = events;
    events = [];
    const endedAt = new Date().toISOString();
    const payload = {
      replay_id: uuidv4(),
      session_id: sessionId,
      path: String(path).split(/[?#]/)[0],
      started_at: startedAt,
      ended_at: endedAt,
      events: batch,
    };
    startedAt = endedAt;
    upload(`${Base_URL}/app/users/analytics/replays`, {
      method: 'POST', credentials: 'include', keepalive: true,
      headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
    }).catch(() => {});
  };

  import('rrweb').then(({ record }) => {
    if (stopped) return;
    stopRecording = record({
      emit(event) {
        events.push(event);
        if (events.length >= 250 || JSON.stringify(events).length >= 450000) flush();
      },
      maskAllInputs: true,
      maskTextFn: maskReplayText,
      blockSelector: 'audio,video,canvas,[contenteditable="true"],.analytics-mask,.analytics-block,[data-sensitive="true"]',
      recordCanvas: false,
      collectFonts: false,
    });
    timer = window.setInterval(flush, 10000);
  }).catch(() => {});

  return () => {
    stopped = true;
    if (timer) window.clearInterval(timer);
    if (stopRecording) stopRecording();
    flush();
  };
}
